/** VISTOERA_CONTENT_PROJECT_DIRECT_CANVAS_AND_FULLSCREEN_CANVAS_SHELL_V1
 * §4/§42 — the retired "AI 创作工作台" route (`content-production/:projectId`
 * with no `/canvas` suffix) now redirects here instead of rendering the
 * old workbench UI. Covers BOTH the old in-app navigation target AND any
 * historical bookmark/internal link shaped like this URL — the canonical
 * destination for a project is always its Production Canvas. */

import { Navigate, useParams } from 'react-router-dom'

export default function ContentProductionProjectRedirect() {
  const { workspaceId = '', projectId = '' } = useParams()
  return <Navigate to={`/workspace/${workspaceId}/content-production/${projectId}/canvas`} replace />
}
